import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { SliderScroll } from '../_app/cuchillo/components/SliderScroll';
import { Metrics } from "assets/scripts/_app/cuchillo/core/Metrics";
import { Power4, gsap } from 'gsap';
import SplitText from 'gsap/SplitText';
import { GetBy } from '../_app/cuchillo/core/Element';
import ScrollItem__Default from './ScrollItem__Default';

class ScrollItem__Headline extends ScrollItem__Default {
    _slider;
    _title;
    _quote;
    _image;
    _body;
    timeLine;


    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this._title = GetBy.class("headline", this.__link);
        this._quote = GetBy.selector(".quote p", this.__link);
        this._image = GetBy.class("div-image", this.__link);
        this._body = GetBy.class("body", this.__link);
        

        this.setUpAnimation();

        this.onShow = () => {

            this.timeLine.restart();
        };
        /*
        this.onHide = () => {};
        */

        this.onMove = () => {}
    }

    //==================================================================================================================
    //          PUBLIC
    //==================================================================================================================

    setUpAnimation() {

        const split_title = new SplitText(this._title, { type: "chars" });
        const split_quote = new SplitText(this._quote, { type: "lines, words " });

        this.doItemsIntoDivs(split_title, 'lines');
        this.doItemsIntoDivs(split_quote, 'lines');

        this.timeLine = gsap.timeline({ paused: true });

        let delay = 0;

        if(!this.item.classList.contains("--title-small")) {
            for (var i = 0; i < (split_title.chars.length); i++) {
                this.timeLine.from(split_title.chars[i], { duration: 1.5, ease: 'power4.out', force3D: true, rotationY: -20 - (5 * i), z: 0 + 20 * i, opacity: 0 }, delay + i * 0.05);
            }

            delay = .5;
        }

        if(this._image[0]) {
            this.timeLine.from(this._image, { duration: 1.5, ease: Power4.easeOut, force3D: true, x: 50, y: 30, z: 40, opacity: 0 }, delay);
            delay = .8;
        }

        for (var i = 0; i < (split_quote.lines.length); i++) {
            this.timeLine.from(split_quote.lines[i], { duration: 1.2 + .1 * i, ease: Power4.easeOut, y: (split_quote.lines[0].offsetHeight * 1.2), force3D: true }, delay + i * 0.05);
        }

        this.timeLine.from(this._body, { duration: 1.2 + .1 * i, ease: Power4.easeOut, alpha: 0, force3D: true }, delay + i * 0.05);
    }

    resize(width, height) {
        super.resize(width, height);
    }


    dispose() {
        super.dispose();
    }
}

Scroll._registerClass('headline', ScrollItem__Headline);